import { createContext } from 'react';

import type { FeatureFlag } from '~/common/types/settings';
import type { CreateBookingRestRequest } from '~/services/bookings/types';

export type Context = {
  featureFlags: FeatureFlag[];
  lastBookingEnquiry: CreateBookingRestRequest | null;
  setLastBookingEnquiry?: (lastBookingEnquiry: CreateBookingRestRequest | null) => void;
};

export const SharedAppStateContext = createContext<Context>({
  lastBookingEnquiry: null,
  featureFlags: [],
});
